import './tabs-slider.scss';

$('.tabs-slider').each(function () {
    let $slider = $(this);

    new window.Swiper($slider.get(0), {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        allowTouchMove: false,
        slidesPerView: 'auto'
    });
});